import ResyRewardsBonus from './ResyRewardsBonus';

export default ResyRewardsBonus;
